import { patchState, updateNestedProp } from "../../../store/utils";

export const getInitialState = () => ({
  syncCache: false,
  syncPending: false,
  finished: false,
  acceptTermAndConditions: false,
  data: {
    generalData: {
      patentes: [
        {
          vehicle: "car",
          patente: undefined,
          reportType: ["COMPLETE"],
        },
      ],
      name: undefined,
      phone: undefined,
      email: undefined,
      emailConfirm: undefined,
      rut: undefined,
      recaptcha: undefined,
    },
    billInfo: {
      address: undefined,
      businessType: undefined,
      economicActivity: undefined,
      rut: undefined,
    },
    paymentType: null,
  },
  reportPayload: {
    email: undefined,
    rut: undefined,
    name_lastname: undefined,
    phone: undefined,
    rut_billing: undefined,
    social_reason: undefined,
    economic_activity: undefined,
    address: undefined,
    payment_type: undefined,
    patents: [],
    recaptcha: undefined,
    uuid: undefined,
  },
  ui: {
    generalDataStepIsDirty: false,
    paymentStepIsDirty: false,
    resumeStepIsDirty: false,
    generalDataStepErrors: [],
  },
});

export const newReportReducers = (state = getInitialState(), action) => {
  switch (action.type) {
    case "NEW_REPORT_UPDATE_NESTED_PROP": {
      return updateNestedProp(state, action.prop.path, action.prop.value);
    }
    case "NEW_REPORT_PATCH_STATE": {
      return patchState(state, action);
    }
    case "UPDATE_BILL_INFO": {
      return updateNestedProp(state, "data.billInfo", action.payload);
    }

    case "UPDATE_PAYMENT_TYPE": {
      return updateNestedProp(state, "data.paymentType", action.payload);
    }

    case "UPDATE_GENERAL_DATA": {
      return updateNestedProp(state, "data.generalData", action.payload);
    }

    case "DELETE_BILL_INFO": {
      return updateNestedProp(
        state,
        "data.billInfo",
        getInitialState().data.billInfo
      );
    }

    case "PAYMENT_SELECTED_IS_DIRTY":
      return updateNestedProp(state, "ui.paymentStepIsDirty", action.payload);

    case "GENERAL_DATA_STEP_IS_DIRTY":
      return updateNestedProp(
        state,
        "ui.generalDataStepIsDirty",
        action.payload
      );

    case "DISABLE_IS_DIRTY":
      let cloned = updateNestedProp(state, "ui.paymentStepIsDirty", false);
      return updateNestedProp(cloned, "ui.resumeStepIsDirty", false);

    case "SET_GENERAL_DATA_ERRORS":
      const errors = Object.keys(action.payload).map((errorField) => {
        if (errorField === "patentes") return "Una de las patentes es inválida";
        if (errorField === "email")
          return "El campo correo es inválido o no coincide con el de confirmación";
        if (errorField === "emailConfirm")
          return "El campo confirmación de correo es inválido o no coincide con el de correo";
        return action.payload[errorField];
      });
      return updateNestedProp(state, "ui.generalDataStepErrors", errors);

    case "NEW_REPORT_RESET":
      return {
        ...getInitialState(),
        syncCache: true,
        finished: false,
        acceptTermAndConditions: false,
      };

    default:
      return state;
  }
};
